import {StaticPartDetailComponentSwitch} from './StaticPartDetailComponentSwitch'
import {StaticPartDetailLabel} from './StaticPartDetailLabel'
import {StaticPartDetailShutdownStatusSwitch} from './StaticPartDetailShutdownStatusSwitch'

import {useShutdowns} from '@refra/modules/common/providers'
import {StaticPartDTO} from '@refra/modules/refra-static-parts/types'

interface StaticPartDetailCardHeaderProps {
  staticPart: StaticPartDTO
}
export const StaticPartDetailCardHeader = ({staticPart}: StaticPartDetailCardHeaderProps) => {
  const {selectedShutdown} = useShutdowns()

  return (
    <div className="flex flex-row gap-4 justify-between mb-4">
      <StaticPartDetailLabel
        partName={staticPart.name}
        shutdownName={selectedShutdown?.name}
        interventionDate={selectedShutdown?.interventionDate}
      />
      <div className={'gap-4 flex flex-row items-center justify-end'}>
        <StaticPartDetailComponentSwitch />
        {selectedShutdown && <StaticPartDetailShutdownStatusSwitch />}
      </div>
    </div>
  )
}
